import { useEffect } from 'react';

export const useDisableVerticalScroll = (isOpen: boolean) => {
	useEffect(() => {
		document.body.style.overflow = isOpen ? 'hidden' : 'unset';
		document.body.style.overflowY = isOpen ? 'hidden' : 'unset';
	}, [isOpen]);
};
